import * as React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw, Modifier } from 'draft-js';

export interface IRichTextTranslationProps {
    value: any;
    isString?: boolean;
}

export default class RichTextTranslation extends React.Component<
    IRichTextTranslationProps,
    any
> {
    static defaultProps = {
        emptyTextAlert: () => {}
    };
    constructor(props) {
        super(props);
    }

    render() {
        const { value, isString } = this.props;
        const editorState =
            !isString && value
                ? EditorState.createWithContent(convertFromRaw(value))
                : EditorState.createEmpty();
        return (
            <React.Fragment>
                <div className="rdw-editor-wrapper readonly">
                    {isString ? (
                        value
                    ) : (
                        <Editor
                            editorState={editorState}
                            toolbar={{ options: [], inline: [] }}
                            readOnly={true}
                        />
                    )}
                </div>
            </React.Fragment>
        );
    }
}
